import { CASABLANCA_HOST } from "../consts";
import { makeAutoObservable, runInAction } from "mobx";

class TenantManager {
    private readonly tenants: Map<string, string>;
    private readonly tenantAdmins: Map<string, string>;

    constructor() {
        this.tenants = new Map<string, string>();
        this.tenantAdmins = new Map<string, string>();
        this.parseCSV(csvData);
        runInAction(() => this.loadFromBackend());

        makeAutoObservable(this);
    }

    private parseCSV(csvData: string): void {
        const rows = csvData.trim().split('\n');
        for (const row of rows) {
            const [tenant, tenantAdmin] = row.trim().split(',');
            if (tenant && tenantAdmin) {
                this.tenants.set(tenant.trim(), tenantAdmin.trim());
                this.tenantAdmins.set(tenantAdmin.trim(), tenant.trim());
            }
        }
    }

    loadFromBackend() {
        // get tenants config from authd via casa BE, and load it into the table
        const endpoint = `${CASABLANCA_HOST}/tenant_list`;
        fetch(endpoint)
          .then(response => response.json())
          .then(data => {
              if (data.length === 0) {
                  console.error("No tenants found");
                  return;
              }
              for (const tenant of data) {
                  if (tenant.tenant_id && tenant.tenant_admin) {
                      if (!this.tenants.has(tenant.tenant_id)) {
                          console.log("adding new tenant", tenant.tenant_id, "-->", tenant.tenant_admin);
                      }
                      this.tenants.set(tenant.tenant_id, tenant.tenant_admin);
                      this.tenantAdmins.set(tenant.tenant_admin, tenant.tenant_id);
                  }
              }
          })
          .catch(error => {
              console.error("Failed to fetch tenant list", error);
          });
    }

    isTenantAdmin(tenantAdmin: string): boolean {
        return this.tenantAdmins.has(tenantAdmin);
    }

    isTenantId(tenantId: string): boolean {
        return this.tenants.has(tenantId);
    }

    getTenantByTenantAdmin(tenantAdmin: string): string | undefined {
        const tenant = this.tenantAdmins.get(tenantAdmin);
        if (!tenant) {
            console.error("No tenant found for tenant admin", tenantAdmin);
        }
        return tenant;
    }

    getTenantAdminByTenant(tenant: string): string | undefined {
        const tenantAdmin = this.tenants.get(tenant);
        if (!tenantAdmin) {
            console.error("No tenant admin found for tenant", tenant);
        }
        return tenantAdmin
    }
}


export default TenantManager;


// tenant,tenant_admin
// two blocks -- main then dv3
const csvData = `
iten44kg8Qa4PCS95GJZhmqyN4EixEVA,
iten33nUeUwb6gx5yZJB3jFMRftWw7HN,iten3PzwU7pDThkCvh3Sow1jrupTshqu
iten3FPBE8Xe3z2XTX1Hr1e5w3ZcT1up,
itenKgBDAkuRzNgShLYoHHWBiz39Lnz,iten2UaEZjMqMfXqjp7W7KYYGQh5zRQ
iten3h6Eo3NT3JsKZs6crss9uqGPdKyS,iten4Dd2keZRUZW9iLAEsg2VJC9PZJwC
iten3VA2SGP9CvErfNBdVHn3PSV6nwLp,
itenLuuuCAMVgE6B3T1oBZQyQsT52e3,itenwY48gXovj36TM7vJN6UyRNU8MqA
iten2dbu685wiHLyjgLnx19jEKxiNb6J,iten2bdviny15TSCyU8ZZfaAJUNZ13P8
iten49urdgHBwbYHAU4KM3zXuNhsCpxd,itenJahtxAmyaivjes57y1zUE23E3Cs
iten4TjbMf8YpUDzK6LakwT8LDP6jcX6,iten28CzvQWowqNdhCvW2iQ35VpapihX
iten4Qku5BJHYragNraUsrkAWvd38rZi,iten3hrwPjzuPn66x3rivXgYpWvYco8A
iten2b4xfachX6wzT6Bn5yHETt6RQoeV,itencHFPeTXByhFcH6NA4FDtR1RRMqw
iten3EwjvYSPt2i7Qgm7zMz2PPsP9gMi,iten2CRa3A4SopDMr3QSxQNPMr1SdzSz
iten35WKExEAC3FgpiQhatuKjphFQosC,iten2PFyWkMHuKpodEsykd1RXLLMhimc
iten3RmQEH4LUZgjCRKagr68xPASnKxL,iten225tXhe49xzQCEfDeSYSHsC837tN
itenw3q9RXY8uuirpGYWpjqqXjPZYyF,iten4XtLsTCjvT7qTr5tv4DTP2JobdeH
iten34Y7Tzso2mRqhzZ6yJDZs2Sqf8L,iten4ZFZ79mhoPyUEmMnR4xFEG3Ag6F
iten2k4UL7KmVUR3gX2DVQuoY2WrKWmU,iten2pq2NNN8c4FkQ3cFbde7hyrnSnSz
iten2g6b5WyAV9FTK8zSS4R4GA4P3WAb,
itenr6GK2BbYZWbTwSnK2UveoR6WU3q,iten2dek8LKQfeMqL9g2aE4rXroHSApz
iten2ZVoxsh4FHM3fvVG3HuCBhfv7r8g,iten2P3kWoEL6EA4uddWY2Mww3PXAE8D
iten3WVLbq6TshXTHYJNVEPNVfqyQXH4,iten2YFWBwFiBrQtt3rtoLZadNYGFzxY
iten26gK4AbsjH89h1zbrBtNEs3Pqiyi,iten3DqwCoerGck9FK2j6GCeMQpnW5Mm
iten2vzGnND83m6bpZnXTwVt2EMKq6Fi,iten2WDiHTQ3Szyxm1VV2DXJSi1dJTJT
itenbBKXzVxdRg2Qvd8U7bKDfSRby6n,iten2JU96Mapj2wWdj15ZKfBhzJmQeM1
itennZxt9euie3NW7cQ1xAVKJjvfJmL,
iten29j4CvEN5FwVK7Vpdsd9zvi7hF3f,itennZDzjnPkbC58j2N1YFw153o7gXb
iten28GVLXxpkwLSLnARAcKH8fTpgHG9,iten3DdTmNkaYkSiYAchCBwHpKRCA8qu
iten4A7Nqkpnbz2j8tewScmja6VP9mhk,iten3RtvWP3WfPMWZbsec2qhG7PDHjEX
itenrhbHEYM7LUDJ5G7WaeSyori99ar,itenYg4BwajufJVZCVunefYbZxr2KxR
iten3B1xqtktWG8fqmdeTv8kGnEvu2yc,itensB1MFkLyhvVMcS2Un5HevEu4MnH
iten2c7n8stKmE8MopetDHvNNBQxwDms,itenzxRELAkZzRKegVJEJe2rQjFbxBV
iten3FoZVUmJM4yS4hXsNPLxytMt4qJ7,iten3kMSymwHhioHCts6WkpaWrLRAev5
iten3LLgfJrNYjpogRTCZEYVKjnjC6nX,iten47dtoWBupUbmJfQ97JdAbCLkHeZc
iten4T34qbBbm6qEWMqnmqrkPZ38MVB8,iten2MCxjcGEXbLiKLKuEV8cNvfynsuE
iten2RUoRe9eR2v33HARQUVSp1rYXzw1,
iten2cwS3myvouXHkbBkUKGHRHsS7ewU,iten2ZEh3NVP7Nt6jQSswPMMxELKHs3v
iten4P9Lm94rTukpRZ8mPcYJHZcXbFVQ,iten41F4hEWUBY2J3iTNmw9tMgDaEv5s
itenjPdKhgS8hYofugnR7ybxJMg1nSK,iten3Vw6myR1oseSb2U9Va8L7ck2gT2e
iten49VKJnKJ5gyrdLoRkBxxnPhcik4v,iten3ZSPfSJTXwkJYAztUw5As4WYtUJ8
iten2D1guACJJyM46BGVPpAQdgtFdZVg,itenvaLrzbX8utzhFVe64TU5ZBvzx5m
iteneozdHLVyDYFrDQvPPeWuoKUaT3M,iten4LrvPrAuZBt44vexW38uwzMq6xH4
iten2fY3bSh8Q7zY1t6vGZ8mUNFLHAWM,iten3wah1Y7HBZSMAJ9vRjcfVw9JkWnQ
iten3wk48FXDEcnTLsQmQaAizfWWB9M6,iten2q4XUiBZKZmbmU1nQfaefonBMES3
iten2GyWiLWuhyQYNa9bYWpq87bsAYyf,iten4E9xWLwJtJbuFkaGfmv3aaJ8Z5nP
iten4CEZmYniuxBsmbNu7rUK3r4DUPg6,iten46Y6bWywtsB6p6WKwwVTtzVhdSUt
iten3NB3HXR9TQuogLk7YSXakNRndGFs,iten3gaJrceQ97V25JeH32unrh8XKqXR
itenmAZkLJuEinNB5xwywSdysnti3N3,iten3SoMsdR3Q7NtiiaEzkFHYhGF7Eg
iten2vpwpJdXcnf2NTBFSniFDzk4dBTu,iten3cxJ3YZXD9nkpxT4i8WC4oArr537
itenbSXLux4a1nydJRm11uZVBLH5BMq,iten2rEEiccBzNmPuW2HZyJBhDXEBrRi
iten3FUjZbbXyysBxExMXQhoBdxJu9gq,iten2MeSGHtEB9UM48TmikWTM6o5Dctb
iten2iNp677ohCdUxtiSqFC2cWkUqLcR,iten4RV4mUYGXaQWiZsLb3ZysWzGzs61
iten4FBgK5GexoJczngdu1i3KKLzfWNP,itenJALbSYiFJwsMWpnWNUxwrgsWu5V
itencaTLKH59S35veimABPLsvu9ercV,iten3KyPXics86uRoEwgqUEcorw3tM4M
iten3K7qdQevqGXuiA7eTB8uGcqBvEwT,iten3f6eD5sUe9ULhq58cuCHZx3zTAAj
iten3N9XcQVz1AENtSfAGCGifwsYLmx8,iten2EpWqyKbwPKKsKMJzdCjevwqp2BU
itenzBg9FfCfA47MH3TsZRfdUvGHHXu,iten3LKpRuDs7RoMipmW5QpQLCQRu8dP
itenRvdA9UrqgFxxNyjqAGfSmku6bHj,iten2PKzesRZiP2nuZMi8mgFvShE2PqM
iten2Cbg46gzePh8pbKAYvBKjJBJK7ww,iten4QJ8YGLS9bJRstNmVipipCGjq4cc
iten2coLVPQuVVW3PfrXGBbs6cZyaC4o,iten4MNJq3C2CRYFGBuS7K8V2a6NwBFP
iten2wAVzZMJVPPDrxeiwNkLyuHc91gC,iten2URymAJBJFjFxgGJ59pxTHENbQbf
itenxteFMvZBKxyWN9qYPDrLcXE1st6,itenXq8VtKe6CagDY4yvftVzZ45nVHQ
iten2aHAzLxhyPeAYQivBcpCTDxq1xiG,iten3QFr4k5HwoA3SY9cpr4EzHcsa1Xq
iten3GTfXJPtxzpoeW6orBzhAtvGxSoK,iten2oENEyu6b7tE294FNYJgrHsvWR7s
iten31QeXeiEwXd3wZ23PXNKXFBpYUZP,itenEvNw5XfnUrmYdvzUqUTVfbzEbRX
iten3CGGbnu3n3qreMfxqEtVNbZcpkfq,itenoAHYmr1aw2DYZj7exvHXKVrnvt5
iten3eZgNgJJCz7LcTtBQ6QcuR5JDrDB,iten3wuCsdMvzVwTWN9MZ6BrhA7jXdJG
iten42GK7y5jpHfkTA4F37g6UsbQba1w,itenLVv2RUHtTQaU5QauUoGDVbbHep7
iten2aYr2mCUKsJ6zL9e5kAXZ2mvDXom,iten2SojFNfcR5UfXKC2ewDLdMC9copD
itenRWtXCgJt81TR9TysaggU3SpjPmZ,iten2cCyXtpvbUtWsatx9mjMAQVfy5Nr
iten3vwNxbqM3BnZn8HekbMJVhRyjA5,itenAqHAFryyiK2QzteePUZknCZPmaD
iten2UMf1zY49DBwNxLCK5dusA6MHmxe,iten2VDgcdrNHkpSjrcPeUit2rtWSQzS
itenPtWD3qbsXGYV5EPSeHezNvztN68,iten3ZVwuMZmqB1rKXJDp1o6WdJDRatQ
iten4QKgVztemsfhzqbG4M3WDqtLExsQ,iten3iY6X82oaxZt6u7rRQzoafTiiaJ6
iten2AcM551T1hgwCuQtTLnWKxkFvo6Y,iten4AcN9pHHKjgA5NJ5bWHmWXEjaTJZ
iten2oYM1fHeGcmwUrKxRH3on7apr4Wm,itenAWPkUuKWfBi1SfFVsGdNyaqHKY4
iten2W71nQsmKvKCFBCiMgTnbwAXzdqM,iten3B2df4y647g2n1ibUpZXrP8dFaC5
iten2CDd7Am7wenS9ZL3j6qsThwg9rkA,iten3na2bhs59hbczNhK7yE62mBiVpbZ
iten34z3BdhSx12ZsTK95AZkZwVxnGi5,itenMN6YoB9fcy4rQuNSRp5NEQuQL4k
iten2eUcewakWK1QAWaqW5JFiXGpBxw7,iten48wU6RtimpnyV9eJmkepS7feAB4V
iten2J64DfbERA7pN54cxYsfuHsm42oP,iten4TAUXgys7z3djJaSb9P9ckPuxJUw
` +
  // dv3
`
iten2Fd7H46YFSzP4UaBDhiQEUBHTnEt,iten4D4ehfrqjSZEzon9zN78PTqXnkix
iten2W8c1Doeu5UptxR1CEaXB9XRrSBx,itengFUzoeuxVvhhWjcoXrwmtgUMag1
iten3Ag9ue2iyq7QqUBgGWsGm8CYdVk6,iten3rFQiejVsQgB5hrZN4NLszGzvSj1
iten3HEEASRTo2rNLeeKw4cfq4sPuX6,iten2u4dccwwWhGwuc9AFByBZCgoWSLc
iten3tNEk7iSesexWeD1mGEZLwqHGMjB,iten3sBNjsLF69WjSgipxuap48Zz198F
iten4TXq2en3qtu3JREnE5tSLRf9zLod,itenXxg7zkXERiXjCUPojNWc6DvZJC9
itenKGHd3iedqtA39krJUPkBTCNoTeX,iten4VJ5cQKvsfdkqNU1iF7RxGsVfpTS
itenQ3XcSXaoS1QRDvTrTNiuhdg6T85,iten3jvf7zt2BQQiFXnWG6Qt1V7xv3jy
itenYQbgk66W1BFEqWr95xPmHZEjmdF,iten3YdSHdHWfAGFaJsKs7J2xJbiMiZW
itengKYCdS5bPGmJ7YTg5qoyqdjzXLd,itenmrxPo8MPyjPQXuCeGRk6rdVa9tn
iteniSQ8XYv7WBKGxmFwHPFz5mwnZDz,itenr3xEWmmbWJ7yvmRQRdUsWtaG43i
`;

